import { render } from "./News.vue?vue&type=template&id=44e6d278&scoped=true&lang=html"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import "./News.vue?vue&type=style&index=0&id=44e6d278&scoped=true&lang=scss"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e6d278"]])

export default __exports__